module.exports = __webpack_public_path__ + "static/media/companynewsImg3.78f702af.jpg";